// CaptionBlockEditor — small, subtle standalone caption text.

import type { CaptionBlock, Block, Align } from "../../../lib/blocks";
import { t } from "../theme";

export interface CaptionBlockEditorProps {
  block: CaptionBlock;
  onChange: (patch: Partial<Block>) => void;
  isSelected: boolean;
}

export function CaptionBlockEditor({
  block,
  onChange,
  isSelected,
}: CaptionBlockEditorProps) {
  return (
    <div>
      {isSelected && (
        <div style={{ display: "flex", gap: 6, marginBottom: 6, fontFamily: t.sans }}>
          {(["left", "center", "right"] as Align[]).map((a) => (
            <button
              key={a}
              type="button"
              onClick={() => onChange({ align: a } as Partial<CaptionBlock>)}
              style={{
                padding: "3px 8px",
                fontSize: 11,
                borderRadius: 4,
                background:
                  (block.align || "center") === a ? t.accentSoft : "transparent",
                color: (block.align || "center") === a ? t.accent : t.text3,
                border: `1px solid ${
                  (block.align || "center") === a ? t.accentStrong : t.border
                }`,
                cursor: "pointer",
                textTransform: "capitalize",
              }}
            >
              {a}
            </button>
          ))}
        </div>
      )}
      <input
        type="text"
        value={block.text}
        onChange={(e) => onChange({ text: e.target.value } as Partial<CaptionBlock>)}
        placeholder="Caption text"
        style={{
          width: "100%",
          boxSizing: "border-box",
          padding: 0,
          background: "transparent",
          border: "none",
          outline: "none",
          fontFamily: t.serif,
          fontStyle: "italic",
          fontSize: 13,
          color: t.text3,
          textAlign: block.align || "center",
        }}
      />
    </div>
  );
}
